export function register(config) {
    if ("serviceWorker" in navigator) {
        window.addEventListener("load", () => {
            const swUrl = `/service-worker.js`;
            navigator.serviceWorker
                .register(swUrl)
                .then((registration) => {
                    if (registration.waiting) {
                        if (config?.onUpdate) config.onUpdate(registration);
                        return;
                    }
                    registration.onupdatefound = () => {
                        const installingWorker = registration.installing;
                        installingWorker.onstatechange = () => {
                            if (
                                installingWorker.state === "installed" &&
                                navigator.serviceWorker.controller
                            ) {
                                if (config?.onUpdate) config.onUpdate(registration);
                            }
                        };
                    };
                })
                .catch((err) => console.log("Error registrando SW", err));
        });
    }

    navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "NEW_VERSION") {
            window.dispatchEvent(new CustomEvent("swUpdated", { detail: { registration: event?.source }}));
        }
    });
}

export function applyUpdate(registration) {
    if (!registration || !registration.waiting) return;
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
    navigator.serviceWorker.addEventListener("controllerchange", () => window.location.reload());
}

export function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then((registration) => registration.unregister());
    }
}

